import { StoreOperations, StoreSubjects } from '../../constants/constants';

export const canCreateLease = (ability) =>
  ability?.can(StoreOperations.Create, StoreSubjects.LeasingRequisition);
export const canCreateNonStdLease = (ability) =>
  ability?.can(StoreOperations.Create, StoreSubjects.LeasingNonStdReq);

export const canRequestReplacementVehicle = (ability) =>
  ability?.can(StoreOperations.Manage, StoreSubjects.VehicleReferral);
